import React, { useMemo } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetLmsLookupTranslationsQuery } from '../../../api';

/**
 * `lms.lookup_translation_t` tanım listelerinden (ör. TRAINING_TYPES, TRAINING_LOCATION)
 * beslenen tekli seçim dropdown'u. Bkz. docs/LMS-Egitim-Katalogu-ve-Egitmenler-API 1.md §2.
 *
 * `value` olarak `code`, etiket olarak aktif dildeki `text` kullanılır — kaydedilen değer
 * her zaman `code`'dur. `X-App-Language` header'ı aktif dile göre otomatik ayarlandığı için
 * ayrıca languageId göndermeye gerek yoktur.
 */
const LmsCodeDropdown = ({ groupCode, value, onChange, placeholder, disabled = false, className = '', invalid = false, id }) => {
    const { data, isLoading } = useGetLmsLookupTranslationsQuery({ groupCode, isActive: 1, pageNumber: 1, pageSize: 100 });

    const options = useMemo(() => {
        const items = data?.items || [];
        return items.map((item) => ({ code: item.code, text: item.text, translations: item.translations }));
    }, [data]);

    return (
        <Dropdown
            id={id}
            value={value ?? null}
            options={options}
            optionLabel="text"
            optionValue="code"
            onChange={(e) => onChange(e.value)}
            placeholder={placeholder}
            loading={isLoading}
            disabled={disabled}
            filter
            showClear
            className={`${className} ${invalid ? 'p-invalid' : ''}`.trim()}
        />
    );
};

export default LmsCodeDropdown;
